import { Button, Loader } from "components/UI/atoms";
import { useCheckoutContext } from "context/checkout-context";
import { useApplyCoupon } from "./utils/useApplyCoupon";
import "./index.scss";

export const CheckoutCouponDiscount = ({
  isCouponAreaOpen,
  setIsCouponAreaOpen
}) => {
  const { isLoading, applyCoupon, removeCoupon } = useApplyCoupon();
  const {
    selectedPayment,
    couponApplied,
    checkoutData: { promo }
  } = useCheckoutContext();

  const toggleCouponArea = () => {
    setIsCouponAreaOpen((currentValue) => !currentValue);
  };

  const handleApplyCouponFormSubmit = async (event) => {
    event.preventDefault();
    setIsCouponAreaOpen(false);
    const promoCode = new FormData(event.target).get("promo-code");
    await applyCoupon({ promoCode, paymentMethodUUID: selectedPayment });
  };

  return (
    <div
      className="checkout-coupon-discount"
      data-testid="checkout-coupon-discount"
    >
      <button className="promo-code" onClick={toggleCouponArea}>
        Use a promo code
      </button>

      {promo?.label && promo?.applied && (
        <div className="checkout-coupon-row">
          <p className="checkout-coupon-label">{promo?.label}</p>
          <button className="coupon-remove" onClick={removeCoupon}>
            Remove
          </button>
        </div>
      )}

      {isCouponAreaOpen && (
        <div className="coupon-form-area" data-testid="coupon-form">
          <form className="coupon-form" onSubmit={handleApplyCouponFormSubmit}>
            <input
              type="text"
              className="promo-input"
              name="promo-code"
              defaultValue={couponApplied}
            />
            <Button
              type="submit"
              variant="outline"
              size="medium"
              customClassName="promo-submit"
            >
              Apply
            </Button>
          </form>
        </div>
      )}
      {isLoading && <Loader variant="secondary" />}
    </div>
  );
};
